// import { session } from '@/helpers/auth';
import { ref, onUnmounted, computed, isRef, Ref } from 'vue';

const activeSockets = new Set<WebSocket>();

export function closeAllWebSockets() {
  activeSockets.forEach((s) => {
    s.close();
  });
  activeSockets.clear();
}

export function useWebSocket<T = unknown>(connectionUrl: string | Ref<string>) {
  // const token = session() || '';
  const socket = ref<WebSocket | null>(null);
  const messages = ref<any[]>([]);
  const error = ref<Event | null>(null);

  const lastMessage = computed<T | null>(() => {
    return messages.value[messages.value.length - 1];
  });

  function connectSocket(initialPayload?: any) {
    const url = isRef(connectionUrl) ? connectionUrl.value : connectionUrl;

    /**
     * Se envía el token como segundo parámetro para incluirlo en el header 'Sec-WebSocket-Protocol' para autenticación.
     * Descomentar cuando back defina la accion para este metodo.
     */
    // socket.value = new WebSocket(url, token);
    socket.value = new WebSocket(url);

    activeSockets.add(socket.value);

    socket.value.onmessage = (event) => {
      try {
        const parsedData = JSON.parse(event.data);
        const allMessages = [...messages.value, parsedData];
        messages.value = allMessages;
      } catch (e) {
        const allMessages = [...messages.value, event.data];
        messages.value = allMessages;
      }
    };

    socket.value.onopen = () => {
      if (initialPayload) {
        send(initialPayload);
      }
    };

    socket.value.onclose = () => {
      if (import.meta.env.VITE_NODE_ENV != 'production') {
        console.log('WebSocket cerrado');
      }
    };

    socket.value.onerror = (err) => {
      console.error('WebSocket error:', err);
      error.value = err;
    };
  }

  function send(data: any) {
    if (socket.value && socket.value.readyState === WebSocket.OPEN) {
      const stringifiedData = JSON.stringify(data);
      socket.value.send(stringifiedData);
    } else {
      console.warn(
        'WebSocket no está abierto o no inicializado. No se pudo enviar el mensaje.'
      );
    }
  }

  function closeSocket() {
    if (socket.value) {
      socket.value.close();
      activeSockets.delete(socket.value);
    }
  }

  onUnmounted(() => {
    closeSocket();
  });

  return { connectSocket, closeSocket, send, messages, lastMessage, error };
}
